import { map } from 'lodash'

const dietExcludedIngredientsDetailsFormInitialValues =
  excludedIngredients => ({
    dietExcludedIngredientIds: map(excludedIngredients, 'id'),
  })

export default dietExcludedIngredientsDetailsFormInitialValues
